import React from 'react';
import { GitBranch } from 'lucide-react';
import ReusableDropdown from "../../../components/ReusableDropdown";
import { escalationTypes, priorities } from "../constants/escalationConstants";
import MappingPreview from "./MappingPreview";
import EmptyState from "./EmptyState";

function MappingForm({
    styles,
    fonts,
    t,
    theme,
    language,
    groups,
    loading,
    formData,
    formErrors,
    handleSubmit,
    handleInputChange,
    getGroupById,
    resetForm,
}) {
    if (loading && groups.length === 0) {
        return <EmptyState styles={styles} fonts={fonts} t={t} loading={true} />;
    }

    if (groups.length === 0) {
        return <EmptyState styles={styles} fonts={fonts} t={t} loading={false} />;
    }

    return (
        <form onSubmit={handleSubmit}>
            <div style={styles.formGrid}>
                {/* Escalation Type */}
                <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                        {t.escalationType} *
                    </label>
                    <ReusableDropdown
                        items={escalationTypes.map(type => ({ key: type, label: type }))}
                        value={formData.escalation_type}
                        onChange={(val) => handleInputChange('escalation_type', val)}
                        placeholder={t.selectType}
                        getItemKey={(item) => item.key}
                        getItemLabel={(item) => item.label}
                        theme={theme}
                        language={language}
                        showAllOnArrowClick={true}
                    />
                    {formErrors.escalation_type && (
                        <span style={styles.errorText}>{formErrors.escalation_type}</span>
                    )}
                </div>

                {/* Priority */}
                <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                        {t.priority} *
                    </label>
                    <ReusableDropdown
                        items={priorities.map(p => ({ key: p, label: p.charAt(0).toUpperCase() + p.slice(1) }))}
                        value={formData.priority}
                        onChange={(val) => handleInputChange('priority', val)}
                        placeholder={t.selectPriority}
                        getItemKey={(item) => item.key}
                        getItemLabel={(item) => item.label}
                        theme={theme}
                        language={language}
                        showAllOnArrowClick={true}
                    />
                    {formErrors.priority && (
                        <span style={styles.errorText}>{formErrors.priority}</span>
                    )}
                </div>
            </div>

            <div style={styles.formGrid}>
                {/* Issuer Group */}
                <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                        {t.issuerGroup} *
                    </label>
                    <ReusableDropdown
                        items={groups}
                        value={formData.issuerGroupId}
                        onChange={(val) => handleInputChange('issuerGroupId', val)}
                        placeholder={t.selectIssuerGroup}
                        getItemKey={(item) => item.groupId}
                        getItemLabel={(item) => `${item.groupName} (ID: ${item.groupId.slice(0, 8)}...) - Creator: ${item.creatorSr}`}
                        theme={theme}
                        language={language}
                        showAllOnArrowClick={true}
                    />
                    {formErrors.issuerGroupId && (
                        <span style={styles.errorText}>{formErrors.issuerGroupId}</span>
                    )}
                </div>

                {/* Assigned Group */}
                <div style={styles.formGroup}>
                    <label style={styles.formLabel}>
                        {t.assignedGroup} *
                    </label>
                    <ReusableDropdown
                        items={groups}
                        value={formData.assignedGroupId}
                        onChange={(val) => handleInputChange('assignedGroupId', val)}
                        placeholder={t.selectAssignedGroup}
                        getItemKey={(item) => item.groupId}
                        getItemLabel={(item) => `${item.groupName} (ID: ${item.groupId.slice(0, 8)}...) - Creator: ${item.creatorSr}`}
                        theme={theme}
                        language={language}
                        showAllOnArrowClick={true}
                    />
                    {formErrors.assignedGroupId && (
                        <span style={styles.errorText}>{formErrors.assignedGroupId}</span>
                    )}
                </div>
            </div>

            {/* Preview Mapping Flow */}
            <MappingPreview
                styles={styles}
                fonts={fonts}
                formData={formData}
                getGroupById={getGroupById}
            />

            {/* Buttons */}
            <div style={styles.buttonGroup}>
                <button
                    type="button"
                    onClick={resetForm}
                    style={styles.cancelBtn}
                >
                    {t.cancel}
                </button>

                <button
                    type="submit"
                    style={styles.submitBtn}
                    disabled={loading}
                    onMouseEnter={(e) => {
                        if (!loading) {
                            e.currentTarget.style.transform = "translateY(-2px)";
                            e.currentTarget.style.boxShadow = "0 0.5rem 1.5rem rgba(46, 124, 186, 0.4)";
                        }
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.transform = "translateY(0)";
                        e.currentTarget.style.boxShadow = "0 0.25rem 0.75rem rgba(46, 124, 186, 0.3)";
                    }}
                >
                    {loading ? (
                        <>
                            <div style={{
                                width: "16px",
                                height: "16px",
                                border: "2px solid rgba(255,255,255,0.3)",
                                borderTopColor: "white",
                                borderRadius: "50%",
                                animation: "spin 0.8s linear infinite"
                            }} />
                            {t.loading}
                        </>
                    ) : (
                        <>
                            <GitBranch size={20} />
                            {t.mapEscalation}
                        </>
                    )}
                </button>
            </div>
        </form>
    );
}

export default MappingForm;